// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const SleepSchoolCognitive = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<circle cx={40} cy={40} r={40} fill="#F7CABB" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.3 25.6c0-3.309 2.692-6 6-6s6 2.691 6 6c0 3.308-2.692 6-6 6s-6-2.692-6-6ZM45.609 54.859c.015-.04.025-.081.037-.121.01-.035.023-.068.03-.103.031-.155.031-.315 0-.47-.007-.036-.02-.069-.03-.103-.012-.04-.022-.081-.037-.121-.018-.04-.04-.077-.061-.115-.017-.03-.031-.062-.05-.092a1.195 1.195 0 0 0-.15-.184l-3.994-3.993a1.2 1.2 0 1 0-1.697 1.697l1.946 1.946H20.5a1.2 1.2 0 0 0 0 2.4h21.103l-1.946 1.946a1.199 1.199 0 1 0 1.697 1.697l3.993-3.994c.057-.056.107-.118.15-.184.02-.03.034-.06.05-.09.022-.04.044-.076.062-.116ZM59.5 38.8h-39a1.2 1.2 0 0 0 0 2.4h39a1.2 1.2 0 0 0 0-2.4ZM34.9 25.6a1.2 1.2 0 0 1 1.2-1.2h23.4a1.2 1.2 0 0 1 0 2.4H36.1a1.2 1.2 0 0 1-1.2-1.2Z"
			fill="#243B4D"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M54.81 60.4c-2.558 0-4.885-1.6-5.79-3.981a.302.302 0 0 1 .066-.319.307.307 0 0 1 .318-.076 5.595 5.595 0 0 0 1.8.297c3.077 0 5.58-2.49 5.58-5.55a5.5 5.5 0 0 0-.36-1.96.303.303 0 0 1 .066-.319.307.307 0 0 1 .318-.076A6.158 6.158 0 0 1 61 54.243c0 3.395-2.777 6.157-6.19 6.157Z"
			fill="#fff"
		/>
	</svg>
);
export default SleepSchoolCognitive;
